import React, { FC, useRef } from "react";
import type { PlatformLocalPaymentOptionsProps } from "@/types";
import { ContentManager } from "../content-manager";
import {Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";
import { A11y, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SplitTextAnimation from "../split-text-animation";
import { SwiperNavigation } from "../swiper";

export const PlatformLocalPaymentOptions: FC<
  PlatformLocalPaymentOptionsProps
> = ({ content, cards }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="localPaymentOptions">
      <div className="localPaymentOptions--inner">
        <div className="wrapper">
          <div className="localPaymentOptions--top">
            <SplitTextAnimation
              htmlElement={
                <ContentManager
                  content={content}
                  className="localPaymentOptions--content"
                  style={{
                    transform: isInView ? "none" : `translateY(20px)`,
                    opacity: isInView ? 1 : 0,
                    transition:
                      "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                  }}
                />
              }
              isInView={isInView}
            />
          </div>
        </div>
        <div className="wrapper wrapper_lg" ref={ref}>
          <Swiper
            modules={[A11y, Navigation]}
            spaceBetween={12}
            slidesPerView={1.1}
            navigation={{
              prevEl:
                ".localPaymentOptions--navigation button:first-of-type",
              nextEl:
                ".localPaymentOptions--navigation button:last-of-type",
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              1280: {
                slidesPerView: 2.45,
                spaceBetween: 32,
              },
            }}
            grabCursor
            className="centralBanksOpenDomesticPayments--swiper"
          >
            <SwiperNavigation className="localPaymentOptions--navigation" />
            {cards.map((card, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className="localPaymentOptions--card"
                  style={{
                    transform: isInView
                      ? "none"
                      : `translateY(${20 * (index + 1)}px)`,
                    opacity: isInView ? 1 : 0,
                    transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                      index * 0.1
                    }s`,
                  }}
                  onMouseEnter={(event) => {
                    const target = event.currentTarget as HTMLElement;
                    target.classList.add("hover-animation-bounce");
                  }}
                  onAnimationEnd={(event) => {
                    const target = event.target as HTMLElement;
                    target.classList.remove("hover-animation-bounce");
                  }}
                >
                  {card.image?.file?.url && (
                    <Image
                      className="localPaymentOptions--card-icon"
                      noInline
                      src={card.image as any}
                      alt={card.image.title}
                      options={{
                        sizes: {
                          exec: [
                            {
                              width: 48,
                              height: 48,
                            },
                          ],
                        },
                      }}
                    />
                  )}
                  {card.description && (
                    <ContentManager
                      content={card.description}
                      className="localPaymentOptions--card-description"
                      style={{
                        transform: isInView
                          ? "none"
                          : `translateY(${20 * (index + 1)}px)`,
                        opacity: isInView ? 1 : 0,
                        transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                          index * 0.1
                        }s`,
                      }}
                    />
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
